import React, { useEffect, useState } from "react";
import { SingleInpuBox } from "../../../../../components/admin/regist/singleInputBox";
import { useGetFaqDetailMutation, useSetFaqMutation, useUpdFaqMutation } from "../../../../../store/admin/adminFaqApiSlice";
import { useNavigate, useParams } from "react-router-dom";

export const RegistFaq = () => {
    const navigate = useNavigate()
    const {contentsId} = useParams()
    const [data, setData] = useState<any>({questionKr : '', questionEn : '', answerKr : '', answerEn : ''})
    const [setFaqApi] = useSetFaqMutation()
    const [getFaqDetailApi] = useGetFaqDetailMutation()
    const [updFaqApi] = useUpdFaqMutation()
    const getDetail = async() => {
        const result : any = await getFaqDetailApi({idx: contentsId})
        if(result.data.result === true){
            setData((prev:any)=>({...prev,
            questionKr: result.data.faq_question_kr, questionEn : result.data.faq_question_en,
            answerKr : result.data.faq_reply_kr, answerEn : result.data.faq_reply_en}))
        }
    }
    const handleSave = async() => {
        const formData : any = new FormData()
        if(contentsId !== 'regist'){formData.append('faq_idx', contentsId)}
        formData.append('faq_question_kr', data?.questionKr)
        formData.append('faq_question_en', data?.questionEn)
        formData.append('faq_reply_kr', data?.answerKr)
        formData.append('faq_reply_en', data?.answerEn)
        if(contentsId === 'regist'){
            const result : any = await setFaqApi(formData)
            if(result.data.result === true){alert("등록이 완료되었습니다."); navigate('/dotsAdmin/customerCenter/faq')}
        }else{
            const result : any = await updFaqApi(formData)
            if(result.data.result === true){alert("수정이 완료되었습니다."); navigate(-1)}
        }
    }
    useEffect(()=>{
        if(contentsId !== 'regist'){
            getDetail()
        }
    }, [contentsId])
    return(
        <>
        <div className="contentBox upload">
            <h3>Customer Center</h3>
            <div className="flexWrap">
                <div className="flexBox">
                    <h4>
                        Add FAQ
                    </h4>
                </div>
                <div>
                    <button className="blackBtn" onClick={()=>navigate(-1)}>목록으로</button>
                    <button className="blueBtn" onClick={handleSave}>저장하기</button>
                </div>
            </div>
            
            <table>
                <tbody>
                    <SingleInpuBox
                        setData={setData}
                        title={'국문 질문'}
                        name={'questionKr'}
                        value={data?.questionKr}
                        placeHolder={'국문 질문을 입력해 주세요.'}
                    />
                    <SingleInpuBox
                        setData={setData}
                        title={'국문 답변'}
                        name={'answerKr'}
                        value={data?.answerKr}
                        placeHolder={'국문 답변을 입력해 주세요.'}
                    />
                    <SingleInpuBox
                        setData={setData}
                        title={'영문 질문'}
                        name={'questionEn'}
                        value={data?.questionEn}
                        placeHolder={'영문 질문을 입력해 주세요.'}
                    />
                    <SingleInpuBox
                        setData={setData}
                        title={'영문 답변'}
                        name={'answerEn'}
                        value={data?.answerEn}
                        placeHolder={'영문 답변을 입력해 주세요.'}
                    />
                </tbody>
            </table>

        </div>
        </>
    )
}